import React from 'react';

import { connect, useSelector } from 'react-redux'

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContentWithDetails from '../../containers/pageContentWithDetails'

import ProjectTable from './ProjectTable'
import ProjectDetails from './ProjectDetails'
import CardHeader from '../../containers/CardHeader'

import { FaPlus } from "react-icons/fa";
import { Card } from 'react-bootstrap'
import InvalidPermissions from '../../containers/InvalidPermissions'

const ProjectSection = (props) => {
    const isSysadmin = useSelector((state) => state.user.isSysadmin)
    const title = "Client Projects";
    const subtitle = "Listing of all Client Projects"
    const headerAction = isSysadmin ? {'path': "/projects/add", 'icon':FaPlus} : {}

    if(!isSysadmin) return <InvalidPermissions /> 

    return (
        <Card>
            <CardHeader title={title} description={subtitle} action={headerAction} />
            <ProjectTable statusFilter={0} showDetailsOnClick={true} />
        </Card>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContentWithDetails(ProjectSection, ProjectDetails), "Projects"));
